import type {
  MeasurementsCapabilityProvider,
  VolumeMeasurementType,
} from '@trimble/web3d-providers';
import { createBaseMeasurementController } from '@trimble/measurements-shared';
import type { VolumeMeasurementController } from './volume-measurement.types';

export function createVolumeMeasurementController(
  provider: MeasurementsCapabilityProvider
): VolumeMeasurementController {
  return {
    type: 'volume',
    ...createBaseMeasurementController<VolumeMeasurementType>(provider, {
      defaultColor: { r: 9, g: 7, b: 12 },
    }),
  };
}
